import React, { useContext } from 'react';
import { Grid, Row, Col } from '@sm/wds-react';
import { LanguageListLO } from './LanguageMenu';
import { AnonFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';
import { SMFooterContext } from './SMFooterContext';

import './footer.scss';

const AnonFooter = () => {
  const { variant } = useContext(SMFooterContext);

  const TrusteFooterSeals = () => {
    return (
      <Col md={5} className="wds-flex  wds-flex--y-center  wds-flex--x-end">
        <TrusteSeals />
      </Col>
    );
  };
  return (
    <div className="sm-footer sm-footer__anon">
      <Grid>
        <Choose>
          <When condition={variant === 'default'}>
            <>
              <Row>
                <Col>
                  <div className="sm-footer--border">
                    <AnonFooterLinks />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="sm-footer--border wds-p-t-4">
                    <LanguageListLO />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={7} className="wds-flex  wds-flex--y-center">
                  <div className="wds-flex__item">
                    <CopyRight />
                  </div>
                </Col>
                {TrusteFooterSeals()}
              </Row>
            </>
          </When>
          <Otherwise>
            <Row>
              <Col md={7} className="wds-flex wds-flex--y-center">
                <div className="wds-flex__item">
                  <AnonFooterLinks />
                  <CopyRight />
                </div>
              </Col>
              {TrusteFooterSeals()}
            </Row>
          </Otherwise>
        </Choose>
      </Grid>
    </div>
  );
};

export default AnonFooter;
